import { createStore, applyMiddleware, compose } from 'redux';
import {createBrowserHistory} from 'history';
import { composeWithDevTools } from 'redux-devtools-extension'
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import rootSaga from './sagas';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middlewares = [thunk, sagaMiddleware, routeMiddleware];

let store = null;

if (process.env.NODE_ENV === 'development'){
  // make trace = true if you want to enable redux-devtools tracing action calls 
  const composeEnhancers = composeWithDevTools({ trace: false, traceLimit: 100 });
  store = createStore(
    reducers,
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    composeEnhancers(applyMiddleware(...middlewares)),
  );
} else {
  store = createStore(
    reducers,
    compose(applyMiddleware(...middlewares))
  );
}

sagaMiddleware.run(rootSaga);
export { store, history };
